function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classPrivateFieldSet(receiver, privateMap, value) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set"); _classApplyDescriptorSet(receiver, descriptor, value); return value; }

function _classApplyDescriptorSet(receiver, descriptor, value) { if (descriptor.set) { descriptor.set.call(receiver, value); } else { if (!descriptor.writable) { throw new TypeError("attempted to set read only private field"); } descriptor.value = value; } }

function _classPrivateFieldGet(receiver, privateMap) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get"); return _classApplyDescriptorGet(receiver, descriptor); }

function _classExtractFieldDescriptor(receiver, privateMap, action) { if (!privateMap.has(receiver)) { throw new TypeError("attempted to " + action + " private field on non-instance"); } return privateMap.get(receiver); }

function _classApplyDescriptorGet(receiver, descriptor) { if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }

import debounce from "lodash/debounce";

var _timeline = /*#__PURE__*/new WeakMap();

var _openState = /*#__PURE__*/new WeakMap();

var _init = /*#__PURE__*/new WeakMap();

var _createElements = /*#__PURE__*/new WeakMap();

var _positionElements = /*#__PURE__*/new WeakMap();

var _createAnimationTimelines = /*#__PURE__*/new WeakMap();

var _setupListeners = /*#__PURE__*/new WeakMap();

var _activate = /*#__PURE__*/new WeakMap();

var _open = /*#__PURE__*/new WeakMap();

var _close = /*#__PURE__*/new WeakMap();

var _toggle = /*#__PURE__*/new WeakMap();

var _toggle2 = /*#__PURE__*/new WeakMap();

var Hamburger = /*#__PURE__*/function () {
  function Hamburger() {
    var _this = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Hamburger);

    _timeline.set(this, {
      writable: true,
      value: void 0
    });

    _openState.set(this, {
      writable: true,
      value: false
    });

    _defineProperty(this, "options", {
      selector: "button.hamburger",
      onOpen: null,
      onClose: null
    });

    _defineProperty(this, "element", null);

    _defineProperty(this, "gsap", undefined);

    _init.set(this, {
      writable: true,
      value: function value() {
        _this.element = document.querySelector(_this.options.selector);

        if (_this.element) {
          _classPrivateFieldGet(_this, _createElements).call(_this).then(_classPrivateFieldGet(_this, _positionElements)).then(_classPrivateFieldGet(_this, _createAnimationTimelines)).then(_classPrivateFieldGet(_this, _activate));
        } else {
          throw new Error("[Hamburger] No element found using the specified selector (".concat(_this.options.selector, ")"));
        }
      }
    });

    _createElements.set(this, {
      writable: true,
      value: function value() {
        return new Promise(function (resolve) {
          _this.topBar = document.createElement("span");
          _this.middleBar = document.createElement("span");
          _this.bottomBar = document.createElement("span");

          _this.element.appendChild(_this.topBar);

          _this.element.appendChild(_this.middleBar);

          _this.element.appendChild(_this.bottomBar);

          resolve();
        });
      }
    });

    _positionElements.set(this, {
      writable: true,
      value: function value() {
        var buttonHeight = _this.element.offsetHeight;
        var barHeight = _this.middleBar.offsetHeight;
        _this.yShift = buttonHeight / 2 - barHeight / 2;
        _this.topBar.style.top = "0px";
        _this.middleBar.style.top = "".concat(_this.yShift, "px");
        _this.bottomBar.style.top = "".concat(2 * _this.yShift, "px");
      }
    });

    _createAnimationTimelines.set(this, {
      writable: true,
      value: function value() {
        // Timing Fns
        var t1 = 0.15;
        var t2 = 0.3; // Delay

        var td = 0.1;

        _this.timeline.to(_this.topBar, t1, {
          y: _this.yShift
        }, 0).to(_this.topBar, t2, {
          rotation: -45
        }, t1 + td);

        _this.timeline.to(_this.middleBar, 0, {
          opacity: 0
        }, t1);

        _this.timeline.to(_this.bottomBar, t1, {
          y: -_this.yShift
        }, 0).to(_this.bottomBar, t2, {
          rotation: 45
        }, t1 + td);
      }
    });

    _setupListeners.set(this, {
      writable: true,
      value: function value() {
        _this.element.addEventListener("click", _classPrivateFieldGet(_this, _toggle2));
      }
    });

    _activate.set(this, {
      writable: true,
      value: function value() {
        // Enable public methods
        _this.open = _classPrivateFieldGet(_this, _open);
        _this.close = _classPrivateFieldGet(_this, _close);
        _this.toggle = _classPrivateFieldGet(_this, _toggle2);

        _classPrivateFieldGet(_this, _setupListeners).call(_this);
      }
    });

    _open.set(this, {
      writable: true,
      value: function value() {
        // this.openAnim.play(0);
        _this.timeline.play();

        _classPrivateFieldSet(_this, _openState, true);

        if (typeof _this.options.onOpen === "function") {
          _this.options.onOpen();
        }
      }
    });

    _close.set(this, {
      writable: true,
      value: function value() {
        // this.closeAnim.play(0);
        _this.timeline.reverse();

        _classPrivateFieldSet(_this, _openState, false);

        if (typeof _this.options.onClose === "function") {
          _this.options.onClose();
        }
      }
    });

    _toggle.set(this, {
      writable: true,
      value: function value() {
        if (_classPrivateFieldGet(_this, _openState)) {
          _classPrivateFieldGet(_this, _close).call(_this);
        } else {
          _classPrivateFieldGet(_this, _open).call(_this);
        }
      }
    });

    _toggle2.set(this, {
      writable: true,
      value: debounce(_classPrivateFieldGet(this, _toggle), 200, {
        leading: true,
        trailing: false
      })
    });

    _defineProperty(this, "open", function () {// Do nothing until ready
    });

    _defineProperty(this, "close", function () {// Do nothing until ready
    });

    _defineProperty(this, "toggle", function () {// Do nothing until ready
    });

    this.options = _objectSpread(_objectSpread({}, this.options), options);
    import('gsap').then(function (_ref) {
      var gsap = _ref.gsap;
      _this.gsap = gsap;
    }).then(function () {
      _classPrivateFieldGet(_this, _init).call(_this);
    });
  }

  _createClass(Hamburger, [{
    key: "timeline",
    get: function get() {
      // Caching
      if (!_classPrivateFieldGet(this, _timeline)) {
        _classPrivateFieldSet(this, _timeline, this.gsap.timeline({
          paused: true
        }));
      }

      return _classPrivateFieldGet(this, _timeline);
    }
  }]);

  return Hamburger;
}();

export { Hamburger as default };